import { lazy } from 'react'

import { bankingServicesItemData } from 'sections/PromoSection/pages/BankingServicesPage/components/BankingServicesItem/data/BankingServicesItemData'
import { Margin, TextPromo } from 'components/ui'
import { Container } from 'components/ui/Container/Container'
import { Title } from 'components/ui/Title/Title'
import { useResize } from 'utils/hooks/useResize'

import BankingServicesItem from './components/BankingServicesItem/BankingServicesItem'

import s from './BankingServicesPage.module.scss'

const BankingServicesPage = () => {
  const { isMobile } = useResize()

  const fontSize = isMobile ? 's20' : 's24'
  return (
    <main className={s.BankingServicesPage}>
      <Container disableMaxWidth>
        <div className={s.titleWrapper}>
          <Title className={s.title}>Банковские услуги</Title>
          <TextPromo size={fontSize} fontFamily="ASLHaussVF">
            Посмотрите условия, которые предлагают наши банки-партнёры
          </TextPromo>
        </div>
        <ul className={s.ul}>
          {bankingServicesItemData.map((item) => (
            <BankingServicesItem key={item.id} title={item.title} id={item.id} link={item.link} imgUrl={item.imgUrl} />
          ))}
        </ul>
        <Margin mt={48} />
        <TextPromo size={'s20'} fontFamily="ASLHaussVF" color="gray" className={s.text}>
          Чтобы зарегистрировать юридическое лицо или ИП, воспользуйтесь услугами партнёров ООО «РВБ» или обратитесь в
          регистрирующий орган с необходимыми документами и квитанцией об оплате государственной пошлины
        </TextPromo>
      </Container>
    </main>
  )
}

export default BankingServicesPage

export const BankingServicesPageAsync = lazy(() => import('./BankingServicesPage'))
